import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})

export class WhatsNewService {
  private httpClient = inject(HttpClient);

  private readonly whatsNewBaseUrl = AppService.get('whatsNewURL');

  getAllRelease$(yearMonth: string): Observable<any> {
    return this.httpClient.get(`${this.whatsNewBaseUrl}/${yearMonth}whats-new.json`)
      .pipe(
        catchError((error) => {
          console.error(error);
          return of(null);
        }),
      );
  }

  getReleaseMarkdown$(url): Observable<string> {
    return this.httpClient.get(url, { responseType: 'text' });
  }
}
